export default __webpack_public_path__ + "static/TIMBERLINE-L-SERIES-28-O-front-side-back-WEB-THUMB-8967c09f2bd188e406f2eee97068ee43.jpg";